<template>
  <ManySearch route_type='drive'/>
</template>

<script>
import ManySearch from "@/components/common/views/search/neibuSearch.vue";
export default {
    components:{
        ManySearch
    }
}
</script>